export default __webpack_public_path__ + "static/media/5.50846f61.jpg";